import { Routes } from '@angular/router';
import { LoginBroadfactorComponent } from './pages/auth/containers/login-broadfactor/login-broadfactor.component';
import { ForgotPasswordComponent } from './pages/auth/containers/forgot-password/forgot-password.component';
import { RecoverPasswordComponent } from './pages/auth/containers/recover-password/recover-password.component';
import { StateResolverService } from './core/resolvers/state-resolver.service';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginBroadfactorComponent,
    title: 'Login - Broadfactor',
  },
  {
    path: 'esqueci-minha-senha',
    component: ForgotPasswordComponent,
    title: 'Esqueci minha senha - Broadfactor',
  },
  {
    path: 'nova-senha/:hash',
    component: RecoverPasswordComponent,
    title: 'Nova senha - Broadfactor',
  },
  {
    path: 'cedente',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () =>
      import('../app-old-lead/old-lead.module').then((m) => m.OldLeadModule),
    resolve: { state: StateResolverService },
    title: 'Operações - Cedente',
  },
  {
    path: 'comprador',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () =>
      import('../app-old-buyer/old-buyer.module').then((m) => m.OldBuyerModule),
    resolve: { state: StateResolverService },
    title: 'Operações - Comprador',
  },
  { path: '**', redirectTo: 'login', pathMatch: 'full' },
];
